import axios from 'axios';
import { Message } from 'element-ui';
import { clearAuth, getToken, setToken, authVersion } from './storage';

const UNAUTHORIZED_CODE = 40101;
const REFRESH_TOKEN_HEADER = 'x-access-token';

let authRedirecting = false;

const service = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || 'http://localhost:8080/admin',
  timeout: 10000
});

service.interceptors.request.use(
  config => {
    config.authVersion = authVersion();
    const token = getToken();
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => Promise.reject(error)
);

service.interceptors.response.use(
  response => {
    if (response.config.authVersion !== authVersion()) return Promise.reject(new Error('登录状态已变更，请重试'));
    const res = response.data;
    const refreshedToken = response.headers[REFRESH_TOKEN_HEADER];
    if (refreshedToken) {
      setToken(refreshedToken, true);
    }

    if (response.config && response.config.responseType === 'blob') {
      return response;
    }

    if (res && Number(res.code) === UNAUTHORIZED_CODE) {
      handleUnauthorized(res.message);
      return Promise.reject(new Error(res.message || '登录已失效，请重新登录'));
    }

    if (res && Number(res.code) !== 200) {
      return Promise.reject(new Error(res.message || '请求失败'));
    }
    return res;
  },
  error => {
    if (error.config && error.config.authVersion !== authVersion()) return Promise.reject(new Error('登录状态已变更，请重试'));
    if (error && error.response && Number(error.response.status) === 401) {
      handleUnauthorized('登录已失效，请重新登录');
    }
    if (error && error.response && error.response.status === 403) return Promise.reject(new Error('没有此模块的操作权限，请联系管理员'));
    return Promise.reject(error);
  }
);

function handleUnauthorized(message) {
  clearAuth();
  if (authRedirecting) {
    return;
  }
  authRedirecting = true;
  Message.error(message || '登录已失效，请重新登录');
  if (window.location.hash !== '#/login') {
    window.location.hash = '/login';
  }
  window.setTimeout(() => {
    authRedirecting = false;
  }, 500);
}

export default service;
